{
	"title": "Kommentare",
	"attachmentsBy": "Anhänge von {{author}} · {{date}}",
	"statuses": {
		"inValidation": "In Validierung",
		"rejected": "Abgelehnt",
		"assured": "Bestätigt",
		"flagged": "Markiert",
		"resolved": "Gelöst"
	}
}
